import { apiClient } from "./client";

function buildIikoPeriodBody(id, dateFrom, dateTo, groupByRestaurant = false, restaurantGroup = null) {
  const body = {
    id,
    dateFrom,
    dateTo,
    groupByRestaurant: Boolean(groupByRestaurant),
  };
  // No trim() on the value itself — see http/DataRequest.js's buildIikoPeriodBody
  // for why: it's iiko's exact group name, sent straight into a server-side
  // IncludeValues filter that needs an exact match.
  if (restaurantGroup != null && String(restaurantGroup).trim() !== "") {
    body.restaurantGroup = String(restaurantGroup);
  }
  return body;
}

export async function getIikoData(id, dateFrom, dateTo, groupByRestaurant = false, restaurantGroup = null) {
  const res = await apiClient.post(
    "/dash/iiko/getdatas",
    buildIikoPeriodBody(id, dateFrom, dateTo, groupByRestaurant, restaurantGroup),
  );
  return res.data;
}

export async function getIikoOlapData(id, dateFrom, dateTo, groupByRestaurant = false, restaurantGroup = null) {
  const res = await apiClient.post(
    "/dash/iiko/olapdatas",
    buildIikoPeriodBody(id, dateFrom, dateTo, groupByRestaurant, restaurantGroup),
  );
  return res.data;
}

export async function getWaitersDatas(id, dateFrom, dateTo, groupByRestaurant = false, restaurantGroup = null) {
  const res = await apiClient.post(
    "/dash/iiko/getwaiters",
    buildIikoPeriodBody(id, dateFrom, dateTo, groupByRestaurant, restaurantGroup),
  );
  return res.data;
}

export async function getDishStats(
  id,
  dateFrom,
  dateTo,
  groupByRestaurant = false,
  restaurantGroup = null,
  { full = false } = {},
) {
  const body = buildIikoPeriodBody(id, dateFrom, dateTo, groupByRestaurant, restaurantGroup);
  if (full) body.full = true;
  const res = await apiClient.post("/dash/iiko/dishstats", body);
  return res.data;
}

export async function getIikoEventsFilter(body) {
  const res = await apiClient.post("/dash/iiko/eventsfilter", body);
  return res.data;
}

export async function getIikoCashShifts(body) {
  const res = await apiClient.post("/dash/iiko/cashshifts", body);
  return res.data;
}
